import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import home from './pages/home.vue'
import iframe from './pages/iframe.vue'
import direct from './pages/direct.vue'

Vue.use(VueAxios, axios)
Vue.use(VueRouter)

const router =  new VueRouter({
  routes: [
    { path: '/', redirect: '/home' },
    { path: '/dashboard', redirect: '/iframe' },
    { path: '/login', redirect: '/direct' },
    {
      path: '/home',
      name: 'Home',
      component: home
    },
    {
      path: '/iframe',
      name: 'iframe',
      component: iframe
    },
    {
      path: '/direct',
      name: 'direct',
      component: direct
    }
  ]
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  render: h => h(App),
  router: router,
}).$mount('#app')
